import { useDispatch, useSelector } from "react-redux";
import { CreateAuthSlice } from "../../redux/slices/createUser";
import Slider from "react-slick";
import { Suspense, useEffect, useState } from "react";
import Sockets from "../../components/default";
import { sendAblyMessage } from "../../lib/socket";

const Rightsidebar = ({ data, socket }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const dispatch = useDispatch();
  const user = useSelector((val) => val?.login?.user);
  const currentDaa = useSelector((val) => val?.usercreate);

  return (
    <>
      {data?.length > 0 ? (
        <aside
          className=" px-6 py-10 bg-gradient-to-b custom-border shadow-lg rounded-xl flex-shrink-0 relative
           overflow-hidden overflow-y-scroll scrollbar-thin scrollbar-thumb-[#c246a5]
            scrollbar-track-gray-300 hidden lg:block"
          style={{
            maxHeight: "800px",
          }}
        >
          <div
            className="flex sticky justify-center items-center
             bg-gradient-to-r text-white text-center py-3  top-0 left-0 right-0 z-10"
            style={{
              background:
                "linear-gradient(to bottom, #c246a5,#ac1182, #c81f92)",
            }}
          >
            <h3 className="text-sm font-bold mb-0 leading-none inline-block">
              ADD GAMING PLATFORMS
            </h3>
          </div>

          <div className="space-y-4 mt-3">
            <Suspense
              fallback={
                <div className="spinner-border text-light" role="status">
                  <span className="visually-hidden">Loading...</span>
                </div>
              }
            >
              {data?.length > 0 &&
                data.map((platform, idx) => {
                  const object = {
                    name: user?.name,
                    username: platform.username,
                    uid: user?.id,
                    gameid: platform._id,
                    slug: platform.slug,
                  };
                  return (
                    <div
                      key={idx}
                      className="relative flex items-center rightbar p-1 rounded-lg shadow"
                    >
                      <button
                        onClick={() => {
                          dispatch(CreateAuthSlice(object));
                          setActiveIndex(idx);
                          // SendToUser("admin-456", {
                          //   ...data,
                          //   userId: object?.uid,
                          // });
                          sendAblyMessage(
                            "admin-chennal",
                            user?.id,
                            "admin-456",
                            "private"
                          );
                        }}
                        disabled={activeIndex === idx && currentDaa?.loading}
                        className={`absolute top-2 right-2 py-0 px-2 rounded-lg font-bold text-sm ${
                          currentDaa?.loading &&
                          object?.gameid === currentDaa?.gameid
                            ? ""
                            : platform?.status === "active"
                            ? "bg-yellow-400 text-black hover:bg-yellow-500"
                            : "bg-yellow-400 text-black hover:bg-yellow-500"
                        }`}
                      >
                        {activeIndex === idx && currentDaa?.loading ? (
                          <div role="status">
                            <svg
                              className="text-red-300 animate-spin"
                              viewBox="0 0 64 64"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                              width="18"
                              height="18"
                            >
                              <path
                                d="M32 3C35.8083 3 39.5794 3.75011 43.0978 5.20749C46.6163 6.66488 49.8132 8.80101 52.5061 11.4939C55.199 14.1868 57.3351 17.3837 58.7925 20.9022C60.2499 24.4206 61 28.1917 61 32C61 35.8083 60.2499 39.5794 58.7925 43.0978C57.3351 46.6163 55.199 49.8132 52.5061 52.5061C49.8132 55.199 46.6163 57.3351 43.0978 58.7925C39.5794 60.2499 35.8083 61 32 61C28.1917 61 24.4206 60.2499 20.9022 58.7925C17.3837 57.3351 14.1868 55.199 11.4939 52.5061C8.801 49.8132 6.66487 46.6163 5.20749 43.0978C3.7501 39.5794 3 35.8083 3 32C3 28.1917 3.75011 24.4206 5.2075 20.9022C6.66489 17.3837 8.80101 14.1868 11.4939 11.4939C14.1868 8.80099 17.3838 6.66487 20.9022 5.20749C24.4206 3.7501 28.1917 3 32 3L32 3Z"
                                stroke="currentColor"
                                strokeWidth="8"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                              ></path>
                              <path
                                d="M32 3C36.5778 3 41.0906 4.08374 45.1692 6.16256C49.2477 8.24138 52.7762 11.2562 55.466 14.9605C58.1558 18.6647 59.9304 22.9531 60.6448 27.4748C61.3591 31.9965 60.9928 36.6232 59.5759 40.9762"
                                stroke="currentColor"
                                strokeWidth="8"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                className="text-[#fbd921]"
                              ></path>
                            </svg>
                          </div>
                        ) : (
                          "Add"
                        )}
                      </button>

                      {/* Image */}
                      <img
                        src={`${process.env.REACT_APP_APIURL}/${platform.logo}`}
                        alt={platform.name}
                        className="w-20 h-20 rounded-lg object-contain "
                      />

                      {/* Platform Name */}
                      <div className="ml-4 flex-1">
                        <p className="font-semibold text-[#fbd921] text-lg">
                          {platform.name}
                        </p>
                      </div>
                    </div>
                  );
                })}
            </Suspense>
          </div>
        </aside>
      ) : (
        ""
      )}
    </>
  );
};

export default Rightsidebar;
